import Footer from "../Footer"
import Header from "../Header"
import Introduction from "./Introduction"
import InvestorFeatures from "./InvestorFeatures"

const InvestorWindow = () => {
  return (
    <div className="w-full relative">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `
      linear-gradient(to right, rgba(229,231,235,0.8) 1px, transparent 1px),
      linear-gradient(to bottom, rgba(229,231,235,0.8) 1px, transparent 1px),
      radial-gradient(circle 500px at 20% 20%, rgba(139,92,246,0.3), transparent),
      radial-gradient(circle 500px at 80% 80%, rgba(59,130,246,0.3), transparent)
    `,
          backgroundSize: "48px 48px, 48px 48px, 100% 100%, 100% 100%",
        }}
      />

      <Header />
      <Introduction />
      <InvestorFeatures />
      <Footer />
    </div>
  )
}

export default InvestorWindow
